import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InfoBoxBase } from './info-box-base';
import { InfoBoxNew } from './info-box-new';
import { InfoBoxRenewal } from './info-box-renewal';

export type { Stage } from './info-box-base';

/**
 * Renders the progress info box at the top of the LOA pages, choosing between the
 * new-LOA copy and the renewal copy. Both variants share `info-box-shared.scss`.
 */
@Component({
  selector: 'app-info-box',
  imports: [InfoBoxNew, InfoBoxRenewal],
  templateUrl: './info-box.html',
  styles: ':host { display: block; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBox extends InfoBoxBase {
  isRenewal = input<boolean>(false);
}
